import { getAccessTokenforResourceAsLazy, buildAuthorizationHeader } from 'owa-tokenprovider';
import { getOrigin, isDeepLink } from 'owa-url';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { trace } from 'owa-trace';
import { getCurrentCulture } from 'owa-localize';
import { isFeatureEnabled } from 'owa-feature-flags';

const SIGNAL_WEVE_ENDPOINT = getOrigin() + '/weveb2/api/v1.0/me/insights/subscribe';
const SUPPORTED_MARKETS = ['en-us'];
export default async function postWeveSignal() {
    let headers = new Headers();
    let [token, tokenPromise] = getAccessTokenforResourceAsLazy(getOrigin(), 'PostWeveSignal');
    // If token is not returned synchronously, we need to await on the tokenPromise
    if (!token) {
        token = await tokenPromise;
    }

    headers.append('authorization', buildAuthorizationHeader(token as string));
    const request: RequestInit = {
        method: 'POST',
        headers: headers,
    };

    if (shouldMakeWeveCall()) {
        // Add a timeout to this function so that this api call is made 30 seconds after the lazy load mail module calls it post boot
        // As just having it in post boot did not help with the failures due to excessive calls to mailbox.
        setTimeout(() => {
            fetch(SIGNAL_WEVE_ENDPOINT, request)
                .then(response => {
                    return isSuccessStatusCode(response.status);
                })
                .catch(error => {
                    trace.warn('Failed to signal Weve to update user load ' + error.message);
                    return false;
                });
        }, 30000);
    }
}
// We need to make the myanalytics subscribe call if the feature flag is enabled to skip the locale check
// or if the user locale is en-us and the window is not deeplink.
function shouldMakeWeveCall(): boolean {
    const userCulture = getCurrentCulture();
    if (!isDeepLink() && isFeatureEnabled('auth-activityFeedWeveSignalWithoutLanguage')) {
        return true;
    } else if (
        !isDeepLink() &&
        userCulture &&
        SUPPORTED_MARKETS.includes(userCulture.toLowerCase())
    ) {
        return true;
    }
    return false;
}
